/* eslint-disable no-useless-catch */
import { ProStudioEvents, ProStudioContext } from '../prostudio.xstate.types';
import { normalizeAllNodes } from '../../utils';
import { tableStore } from '../../stores';

export const uploadCsvFile = async (
  _ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<void> => {
  if (event.type !== 'uploadCsvFile') {
    return;
  }

  const { rows, cb } = event.payload;

  try {
    const parsedNodes = normalizeAllNodes(rows);

    await tableStore.uploadCsvToDatabase(parsedNodes);
  } catch (error) {
    throw error;
  } finally {
    cb?.();
  }
};
